<template>
    <div>
        <Header :data_status="data_status"></Header>
        <div>
            <div class="card-block" v-show="data_status != 'loading'">
                <div class="inline" justify="between" valign="center">
                    <h1>Отзыв #{{ $route.params.id }}<router-link class="button _free _second" to="/feedback">К списку</router-link></h1>
                    <div class="inline" :status="request_status">
                        <div v-if="data.solved" class="text-accept">Решено <router-link class="link2" :to="'/users/' + data.solved_by.id" v-if="data.solved_by">{{ data.solved_by.email }}</router-link><span v-if="data.solved_at"> в {{ data.solved_at }}</span></div>
                        <div v-else class="button _free _accept" @click="solve()">Отметить как решенное</div>
                    </div>
                </div>
                <form class="card">
                    <div class="inline">
                        <div class="grid">
                            <div class="text-item">
                                <span>Дата</span>
                                <p>{{ data.ctime }}</p>
                            </div>
                            <div class="text-item">
                                <span>Имя</span>
                                <p>{{ data.contact }}</p>
                            </div>
                            <div class="text-item">
                                <span>Email</span>
                                <p>{{ data.email }}</p>
                            </div>
                            <div class="text-item" v-if="data.user">
                                <span>Пользователь</span>
                                <p><router-link class="link2" :to="'/users/' + data.user.id">{{ data.user.email }}</router-link></p>
                            </div>
                            <div class="text-item" v-if="data.parking">
                                <span>Парковка</span>
                                <p><router-link class="link2" :to="'/parking/' + data.parking.id">{{ data.parking.address }}</router-link></p>
                            </div>
                        </div>
                        <div class="grid">
                            <div class="text-item">
                                <span>Тип</span>
                                <p>{{ data.type }}</p>
                            </div>
                            <div v-if="data.address" class="text-item">
                                <span>Адрес</span>
                                <p>{{ data.address }}</p>
                            </div>
                            <div class="text-item" v-if="data.message">
                                <span>Сообщение</span>
                                <p>{{ data.message }}</p>
                            </div>
                            <div class="text-item" v-if="data.other">
                                <span>Другое</span>
                                <p>{{ data.other }}</p>
                            </div>
                        </div>
                        <div class="grid">
                            <div class="text-item" v-if="data.type == 'Complaint' && data.wrong">
                                <h3>Неверные атрибуты:</h3>

                                <table class="table-light">
                                    <tr>
                                        <td>Адрес</td>
                                        <td>{{ data.wrong.address }}</td>
                                    </tr>
                                    <tr>
                                        <td>Цена</td>
                                        <td>{{ data.wrong.price }}</td>
                                    </tr>
                                    <tr>
                                        <td>Расписание</td>
                                        <td>{{ data.wrong.timetable }}</td>
                                    </tr>
                                    <tr>
                                        <td>Другое</td>
                                        <td>{{ data.wrong.other }}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="inline">
                        <div class="grid" v-if="data.price_file">
                            <div class="form-item">
                                <ZoomImage :src="data.price_file"/>
                            </div>
                        </div>
                        <div class="grid" v-if="data.timetable_file">
                            <div class="form-item">
                                <ZoomImage :src="data.timetable_file"/>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="page-load" v-show="data_status == 'loading'">
                <div class="inline" valign="center">
                    <img src="~@/assets/img/preloader.svg" class="preloader"> Загрузка
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Header from '@/components/Header.vue'
    import ZoomImage from '@/components/ZoomImage.vue'

    export default {
        components: {
            Header,
            ZoomImage
        },
        data () {
            return {
                data: {},
                data_status: 'init',
                request_status: '',
            }
        },
        created () {
            this.getData()
        },
        methods: {
            solve () {
                return new Promise((resolve, reject) => {
                    this.request_status = 'loading'
                    this.axios.post('api/admin/v2/feedback/' + this.$route.params.id + '/solve')
                        .then(() => {
                            this.request_status = ''
                            this.data.solved = true
                            resolve()
                        })
                        .catch(() => {
                            this.request_status = ''
                            let msg = {
                                message: 'Ошибка при изменении статуса',
                                status: 'error'
                            }
                            this.$store.dispatch('utils/showMessage', msg)
                            reject()
                        })
                })
            },
            getData () {
                return new Promise((resolve) => {
                    this.data_status = 'loading'
                    this.axios.get('api/admin/v2/feedback/' + this.$route.params.id)
                        .then(resp => {
                            this.data = resp.data.response
                            this.data_status = ''
                            resolve()
                        })
                        .catch(() => {
                            this.$router.push('/feedback')
                        })
                })
            }
        }
    }
</script>
